import { defineComponent as a, openBlock as n, createBlock as r, unref as p, mergeProps as l, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const v = /* @__PURE__ */ a({
  name: "IconLaptop",
  __name: "IconLaptop",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (n(), r(p(i), l(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M3.25 6.5A2.25 2.25 0 0 1 5.5 4.25h13a2.25 2.25 0 0 1 2.25 2.25v8a2.24 2.24 0 0 1-.23.994 2.25 2.25 0 0 1-1.02 4.256h-15a2.25 2.25 0 0 1-1.02-4.256A2.24 2.24 0 0 1 3.25 14.5v-8m2.25 8.75h13a.75.75 0 0 0 .75-.75v-8a.75.75 0 0 0-.75-.75h-13A.75.75 0 0 0 4.75 6.5v8a.75.75 0 0 0 .75.75m13 1.5h-14a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5h-1",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
